<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <template #SHOWSTATUS>
      <order-tracker v-if="statusId" :statusId="statusId"></order-tracker>
    </template>
  </cTable>
</template>

<script>
import { getOverseasOrder,syncDeliver } from "@/api/order/overseasOrderList";
import { getCountry } from "@/api/system/country";
import { getSelectType } from "@/api/public";
import { getWarehouse } from "@/api/storage/warehouse";
import { getChannel } from "@/api/tracker/channel";
import { getAgent } from "@/api/tracker/agent";
import { getStatus } from "@/api/tracker/status";
import { getAllClient } from "@/api/user/client";
import orderTracker from "@/base/order_tracker";
import cTable from "@/base/common/index";
// import format from "@/utils/format";
// import expandRow from "_my/table-expand";
export default {
  name: "overseasOrderList",
  components: {
    cTable,
    orderTracker
  },
  data() {
    return {
      statusId: "",
      methods: {
        list: p => getOverseasOrder(p),
        getCountry,
        getAgent,
        getAllClient,
        getChannel,
        getSelectType,
				syncDeliver
      },
      config: {
        height: 630
      },
      modals: {},
      header: {
        searchs: [
          // {
          //   key: "dateType",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("date") + this.$t("type");
          //   },
          //   clearable: true,
          //   options: [
          //     { label: "周", value: "week" },
          //     { label: "月", value: "month" }
          //   ],
          //   default: "month",
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              // format({ searchForm, value, newFormData }) {
              //   // newFormData.temp = 1;
              //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              // }
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              // format({ searchForm, value, newFormData }) {
              //   // newFormData.temp = 1;
              //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              // }
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              }
            }
          },

          // {
          //   key: "toCountry",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("countryCode");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "code", value: "code" },
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "warehouse_id",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id"
            }
            // methods: {
            //   async list({ field }) {
            //     field.options = (
            //       await getWarehouse({ is_oversea: "NO" })
            //     ).data.payload.rows;
            //     this.$forceUpdate();
            //   }
            // }
          },
          {
            key: "status",
            component: "Select",
            options: [
              { label: this.$t("YES"), value: "YES" },
              { label: this.$t("NO"), value: "NO" }
            ],
            bind: {
              style: {
                width: "150px"
              }
            },
            clearable: true,
            placeholder() {
              return (
                this.$t("whether") + this.$t("placeOrder") + this.$t("success")
              );
            }
          },
          {
            key: "is_deliver",
            component: "Select",
            options: [
              { label: this.$t("YES"), value: "YES" },
              { label: this.$t("NO"), value: "NO" }
            ],
            bind: {
              style: {
                width: "150px"
              }
            },
            clearable: true,
            placeholder() {
              return this.$t("deliver") + this.$t("tip");
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },
						{
						  name: this.$t("batchDelivery"),
						  type: "batchDelivery",
						  fnName: "batchDelivery",
						  disabled() {
						    return !this.selectAll.length;
						  },
						  bind: {
						    type: "primary"
						  },
							id:1528
						}
          ],
          methods: {
            export() {
              this.exportExc();
            },
						batchDelivery() {
						  this.$Modal.confirm({
						    title: this.$t("batchDelivery"),
						    width: 300,
						    content: this.$t("titleModal"),
						    onOk: () => {
						      this.handleRequestMethods(
						        "syncDeliver",
						        {order_id:this.selectAll.map(t=>t.id)},
						        true,
						        true
						      ).then((res) => {
						        this.getList();
						      });
						    },
						  });
						}
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("order_t") + "id",
          key: "id",
          align: "center",
          width: 150
        },
        {
          name: () => this.$t("overseasNumber"),
          key: "mb_awbno",
          width: 150
        },
        {
          name: () => this.$t("Helian") + this.$t("orderNum"),
          align: "center",
          key: "awbno",
          width: 130
        },
        {
          name: () => this.$t("placeOrder") + this.$t("time"),
          key: "order_time",
          align: "center",
          width: 150
        },
        {
          name: () => this.$t("info"),
          key: "msg",
          align: "center"
        },
        {
          name: () => this.$t("whether") + this.$t("canShip"),
          key: "canship",
          methods: {
            render: ({ value }) => {
              return value ? this.$t("YES") : this.$t("NO");
            }
          }
        },
        {
          name: () => this.$t("whether") + this.$t("beenShip"),
          key: "is_deliver",
          methods: {
            render: ({ value }) => {
              return value ? this.$t("YES") : this.$t("NO");
            }
          }
        },
        {
          name: () => this.$t("warehouseName"),
          key: "warehouse"
        },
        {
          name: () => this.$t("clientName"),
          key: "customer"
        }
        // {
        //   type: "btns",
        //   width: 100,
        //   name: () => this.$t("operation"),
        //   fixed: "right",
        //   list: [
        //     {
        //       name: () => this.$t("export"),
        //       type: "export",
        //       fnName: "exportFun",
        //       bind: {
        //         type: "warning"
        //       }
        //     }
        //   ],

        //   methods: {
        //     exportFun({ row }) {
        //       let data = JSON.parse(
        //         JSON.stringify(this.$refs["header"].searchForm)
        //       );
        //       data["staff_id"] = row.staff_id;
        //       data["startTime"] = data["startTime"]
        //         ? this.format.dateFormat(data["startTime"], "YYYY-MM-DD")
        //         : "";
        //       data["endTime"] = data["endTime"]
        //         ? this.format.dateFormat(data["endTime"], "YYYY-MM-DD")
        //         : "";
        //       this.openLoading();
        //       this.handleRequestMethods(
        //         "exportPerformance",
        //         data,
        //         false,
        //         true
        //       ).then(res => {
        //         window.open(this.$globalUrl + res.payload.src);
        //       });
        //     }
        //   }
        // }
      ]
    };
  },
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "warehouse_id")
        item.options = (await getWarehouse()).data.payload.rows;
      // if (item.key === "toCountry")
      //   item.options = (await getCountry()).data.payload.rows;
      // if (item.key === "channelCode")
      //   item.options = (await getChannel()).data.payload.rows;
      // if (item.key === "deliver")
      //   item.options = (
      //     await getAgent({ agent_type: "bag" })
      //   ).data.payload.rows;
      // if (item.key === "noUpdateDay")
      //   item.options = (
      //     await getSelectType(["ANALYZE_SELECT_DAY"])
      //   ).data.payload["ANALYZE_SELECT_DAY"];
      // if (item.key === "trackerStatus")
      //   item.options = (await getStatus({ pageSize: 9999 })).data.payload.rows;
    });
  }
};
</script>
